import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto, UpdateShopExchangeDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateShopExchange(shop: ShopDto) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shop.id);
  const mutation = $api.useMutation("patch", "/shops/{shopId}/exchanges");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async (data: UpdateShopExchangeDto) => {
      return mutation.mutateAsync({
        params: { path: { shopId: shop.id } },
        body: data,
      });
    },
  });
}
